var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bread-crumb"},[_vm._l((_vm.pathList),function(item,q){return [_c('div',{key:q,class:[!item.path ? 'no-cursor' : 'path'],style:({color:!item.path && '#999999'}),on:{"click":function($event){return _vm.goToPath(item.path)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")]),_c('i',{staticClass:"el-icon-caret-right"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }